module.exports = __webpack_public_path__ + "img/HRA Web Banner.29575fc2.png";